const REGULAR_MODULE_TYPE = 'topItem';
const BANNER_MODULE_TYPE = 'topItemBanner';
const PROMO_MODULE_TYPE = 'topItemPromo';

export { REGULAR_MODULE_TYPE, BANNER_MODULE_TYPE, PROMO_MODULE_TYPE };
